import errorManager from '@/rollbar.js';

const setDateOut = () => {
  eventBus.$on('dateIn', (dateIn) => {
    if (dateIn) {
      var newDateOut = formatDateIn(dateIn);
      newDateOut = moment(newDateOut).add(1, 'M').format('DD/MM/YYYY');
    } else {
      newDateOut = '';
    }
    var repeatsEndOnInput = document.getElementById('repeats_end_on');
    repeatsEndOnInput.value = newDateOut;
  });
};

const formatDateIn = (dateIn) => {
  var parsedDateIn = dateIn.split('/');
  parsedDateIn = parsedDateIn[2] + '-' + parsedDateIn[1] + '-' + parsedDateIn[0];
  return parsedDateIn;
};

const init = (domParamDateOut) => {
  try {
    if (domParamDateOut === 'true') {
      setDateOut();
    }
  } catch (e) {
    errorManager(e);
  }
};

window.check_date_out = {
  init,
};
